import React, { useEffect, useState } from 'react'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { Button } from '@app/components';
import { Form, Modal } from 'react-bootstrap';
import moment from 'moment';
import { getAllLeadStatus, updateLeadStatus } from '@app/services/lead';

const UpdateLeadStatusModal = (props) => {

    const [isLoading, setLoading] = useState(false);
    const [leadStauses, setLeadStauses] = useState([]);
    
    useEffect(() => {
        getAllLeadStatusAPI()
    },[]);

    const getAllLeadStatusAPI = async () => {
        try {
            const resp = await getAllLeadStatus()
            if (resp.success === true) {
                setLeadStauses(resp?.collections)
            } else {
                toast.error(resp?.errors[0]?.msg);
            }
        } catch (error: any) {
            toast.error(error?.message || 'Internal server error');
        }
    };

    const { handleChange, values, handleSubmit, touched, errors, resetForm } = useFormik({
        initialValues: {
            lead_inquiry_student_id: props?.payload?.lead_inquiry_student_id ?? '',
            lead_inquiry_student_subject_id: props?.payload?.lead_inquiry_student_subject_id ?? '',
            lead_inquiry_status_id: '',
            parent_email: props?.payload?.parent_email ?? '',
            parent_phone: props?.payload?.parent_phone ?? '',
            status_updated_date: moment().format('YYYY-MM-DD'),
            comment: ''
        },
        validationSchema: Yup.object({
            lead_inquiry_student_id: Yup.string().required('Something went wrong'),
            lead_inquiry_student_subject_id: Yup.string().required('Please select subject'),
            lead_inquiry_status_id: Yup.string().required('Please select status'),
            parent_phone: Yup.string().trim().when("lead_inquiry_status_id", {
                            is: (val: string) => (val == '7' || val == '8'),
                            then: Yup.string().required('Please enter parent contact number')
                                .matches(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/,
                                    "Please enter valid number"
                                ),
                        }),
            parent_email: Yup.string().trim().when("lead_inquiry_status_id", {
                            is: (val: string) => (val == '7' || val == '8'),
                            then: Yup.string().required('Please enter parent email'),
                        }),
            status_updated_date: Yup.date().required('Please enter date'),
            comment: Yup.string().required('Please enter a comment'),
        }),
        onSubmit: (values) => {
            updateLeadStatusAPI(values);
        },
        enableReinitialize: true,
    });

    const updateLeadStatusAPI = async (payload) => {
        try {
            setLoading(true);
            const resp = await updateLeadStatus(payload);
            if(resp.success === true){
                setLoading(false);
                resetForm()
                toast.success(resp?.message);
                props.handleClose();
                props.reload();
            }else{
                toast.error(resp?.errors[0]?.msg);
                setLoading(false);
            }
        } catch (error: any) {
            setLoading(false);
            toast.error(error?.message || 'Internal server error');
        }
    };

    return (
    <div>
        <Modal show={props.show} onHide={props.handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Update Lead Status</Modal.Title>
            </Modal.Header>
            <form onSubmit={handleSubmit}>
                <Modal.Body>
                    <div className='row'>
                        <div className="col-sm-12">
                            <div className="form-group">
                                <label htmlFor="exampleInputEmail1">Subject <span className="required">*</span></label>
                                <select
                                    className="form-control"
                                    name='lead_inquiry_student_subject_id'
                                    onChange={handleChange}
                                    value={values.lead_inquiry_student_subject_id}
                                >
                                    <option value="">Please select subject</option>
                                    <option value="all">All Subject(s)</option>
                                    { props.type != 'view-journey' && (
                                        <option value={props?.payload?.lead_inquiry_student_subject_id}>{props?.payload?.subject_name}</option>
                                    )}
                                    { props.type == 'view-journey' && props.payload.subjects && 
                                        props.payload.subjects.map((obj) => (
                                            <option key={obj.lead_inquiry_student_subject_id} value={obj.lead_inquiry_student_subject_id}>
                                                {obj.subject_name}
                                            </option>
                                        ))
                                    }
                                </select>
                                {(touched.lead_inquiry_student_subject_id && errors.lead_inquiry_student_subject_id) && (
                                    <div className="text-danger">
                                        {errors.lead_inquiry_student_subject_id}
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="col-sm-12">
                            <div className="form-group">
                                <label htmlFor="exampleInputEmail1">Status <span className="required">*</span></label>
                                <select
                                    className="form-control"
                                    name='lead_inquiry_status_id'
                                    onChange={handleChange}
                                    value={values.lead_inquiry_status_id}
                                >
                                    <option value="">Please select status</option>
                                    {leadStauses.map((obj) => (
                                        <option key={obj.id} value={obj.id}>
                                            {obj.name}
                                        </option>
                                    ))}
                                </select>
                                {(touched.lead_inquiry_status_id && errors.lead_inquiry_status_id) && (
                                    <div className="text-danger">
                                        {errors.lead_inquiry_status_id}
                                    </div>
                                )}
                            </div>
                        </div>
                        { (values.lead_inquiry_status_id == '7' || values.lead_inquiry_status_id == '8') && (
                            <>
                            <div className="col-sm-12">
                                <div className="form-group">
                                    <label htmlFor="parent_phone">Parent Contact (WhatsApp Number) <span className="required">*</span></label>
                                    <Form.Control 
                                        type="number" 
                                        name="parent_phone" 
                                        id="parent_phone" 
                                        placeholder="Enter Phone" 
                                        value={values.parent_phone}
                                        onChange={handleChange}
                                    />
                                    {(touched.parent_phone && errors.parent_phone) && (
                                        <div className="text-danger">
                                            {errors.parent_phone}
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="col-sm-12">
                                <div className="form-group">
                                    <label htmlFor="parent_email">Parent Email <span className="required">*</span></label>
                                    <Form.Control 
                                        type="email" 
                                        name="parent_email" 
                                        id="parent_email" 
                                        placeholder="Enter Email" 
                                        value={values.parent_email}
                                        onChange={handleChange}
                                        disabled={props?.payload?.parent_read_only}
                                    />
                                    {(touched.parent_email && errors.parent_email) && (
                                        <div className="text-danger">
                                            {errors.parent_email}
                                        </div>
                                    )}
                                </div>
                            </div>
                            </>
                        )}
                        <div className="col-sm-12">
                            <div className="form-group">
                                <label htmlFor="exampleInputEmail1">Date <span className="required">*</span></label>
                                <Form.Control 
                                    type="date" 
                                    name="status_updated_date" 
                                    id="status_updated_date" 
                                    placeholder="Enter date" 
                                    value={moment(values.status_updated_date).format('YYYY-MM-DD')}
                                    onChange={handleChange}
                                />
                                {(touched.status_updated_date && errors.status_updated_date) && (
                                    <div className="text-danger">
                                        {errors.status_updated_date}
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="col-sm-12">
                            <div className="form-group">
                                <label htmlFor="exampleInputEmail1">Comment <span className="required">*</span></label>
                                <textarea 
                                    className="form-control" 
                                    id="exampleInputEmail1" 
                                    placeholder="Please enter comment" 
                                    name="comment" 
                                    onChange={handleChange} 
                                    value={values.comment}
                                    rows={3}
                                ></textarea>
                                {(touched.comment && errors.comment) && (
                                    <div className="text-danger">
                                        {errors.comment}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button type="submit" isLoading={isLoading} className="btn btn-primary mr-2">Save </Button>
                    <Button className='btn btn-default' onClick={props.handleClose}>Close</Button>
                </Modal.Footer>
            </form>
        </Modal>
    </div>
  )
}

export default UpdateLeadStatusModal;